import React from 'react'
import pdf from '../../../../static/Anexo_tarifas.pdf'

function TarifasVigentes () {
  return (
    <iframe
      title='Anexotarifas'
      src={pdf}
      style={{ width: '100%', minHeight: '85vh', marginTop: '-2%' }}
    />
  )
}

export default TarifasVigentes
